/**
 * DedupFlagBadge — Phase R10.3 (2026-07-04)
 *
 * Color-coded pill for the R10.1/R10.2 dedup_flag field.
 *   - green  → "Clean"               (bg-emerald-500)
 *   - yellow → "Review"              (bg-amber-500)
 *   - orange → "Potential Duplicate" (bg-orange-500)
 *   - red    → "Confirmed Duplicate" (bg-red-600)
 *
 * null / missing → treated as "green". Hover tooltip surfaces
 * `dedup_flag_reason` when present.
 */
import { CheckCircle2, AlertTriangle, AlertOctagon, Shield } from 'lucide-react';

const CONFIG = {
  green:  { label: 'Clean',               cls: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/40', Icon: CheckCircle2 },
  yellow: { label: 'Review',              cls: 'bg-amber-500/15 text-amber-300 border-amber-500/40',       Icon: AlertTriangle },
  orange: { label: 'Potential Duplicate', cls: 'bg-orange-500/15 text-orange-300 border-orange-500/40',    Icon: AlertTriangle },
  red:    { label: 'Confirmed Duplicate', cls: 'bg-red-600/20 text-red-300 border-red-600/40',             Icon: AlertOctagon },
};

export default function DedupFlagBadge({ flag, reason, size = 'md' }) {
  const key = (flag || 'green').toLowerCase();
  const cfg = CONFIG[key] ?? CONFIG.green;
  const padding = size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-[11px]';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-semibold whitespace-nowrap ${padding} ${cfg.cls}`}
      title={reason || cfg.label}
      data-testid={`dedup-flag-badge-${key}`}
    >
      <cfg.Icon size={size === 'sm' ? 10 : 12} />
      {cfg.label}
    </span>
  );
}
